import { Tooltip, TooltipPlacement } from './Tooltip';
import { OptionalTooltip } from './OptionalTooltip';

export type { TooltipPlacementWithStrings } from './Tooltip';
export { TooltipPlacement, OptionalTooltip };
export default Tooltip;
